var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.$store.getters.lang === 'es')?_c('div',[_c('introES'),_c('termsES')],1):_c('div',[_c('introEN'),_c('termsEN')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }